"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var markConversationsAsPhishingFromTable_1 = require("./markConversationsAsPhishingFromTable");
var markItemsAsPhishingFromTable_1 = require("./markItemsAsPhishingFromTable");
function markRowsAsPhishingFromTable(rowKeys, tableView, actionSource) {
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            markConversationsAsPhishingFromTable_1.default(rowKeys, tableView, actionSource);
            break;
        case 1 /* Message */:
            markItemsAsPhishingFromTable_1.default(rowKeys, tableView, actionSource);
            break;
    }
}
exports.default = markRowsAsPhishingFromTable;
//# sourceMappingURL=markRowsAsPhishingFromTable.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/markRowsAsPhishingFromTable.js
// module id = 5610
// module chunks = 62